import { observable, action, computed } from 'mobx';
import { toast } from "react-toastify";
import FirebasePublicMeetingService from "../services/impl/firebase/FirebasePublicMeetingService";
import IPublicMeetingService  from '../services/spi/IPublicMeetingService';
import FirebaseService from "./../services/impl/firebase/FirebaseService";
import IMeeting, { convertToMeeting } from "./../types/IMeeting";

class PublicMeetingStore {
    @observable meeting = {
      title: '',
      participants: [[{ displayName: '', status: '' }]],
      presenter: {
        status: '',
        displayName: ''
      },
      presentation: {},
      uid: ""
    } as unknown as IMeeting;
  
  rootStore:any = null;
  publicMeetingService = {} as IPublicMeetingService;
  userId:string = "";
  meetingId:string = "";

  constructor(rootStore:any) {
    this.rootStore = rootStore;
    this.publicMeetingService = new FirebasePublicMeetingService();
  }

  @action loadMeeting = () => {
    FirebaseService.getInstance()
      .meeting(this.userId, this.meetingId)
      .on("value", (snapshot: { val: () => { title: string; participants: { displayName: string; status: string; }[][]; presenter: { status: string; displayName: string; }; presentation: {}; }; key: any; }) => {
        const m:any = snapshot.val();
        const key:string = snapshot.key;
        this.meeting = convertToMeeting(m);
        this.meeting.uid = key;
      });
  };

  @action joinMeeting = () => {
    const ref = "/users/" + this.userId + "/meetings/" + this.meetingId + "/participants/0/";
    this.updateAttribute(ref, "status", "ONLINE");
    const audioRef = "/users/" + this.userId + "/meetings/" + this.meetingId + "/participants/0/audio";
    this.updateAttribute(audioRef, "optedIn", false);
  }

  @action registerListeners = () => {

  }

  onValueChange = (oldMeeting: any, newMeeting: any) =>{
    //TODO: write logic here to see if the participant status changed.
    //This can be used to raise onetime events like playSound() or show Toast
  }

  _slideChanged = () => {
      
  }

  updateAttribute = (refPath: any, attrName: string, attrValue: any) => {
    const updateObj = {} as any;
    updateObj["" + attrName] = attrValue;
    FirebaseService.getInstance()
      .database()
      .ref(refPath)
      .update(updateObj, function (error: any) {
        if (error) {
          toast.info("Couldnot join meeting. Failed!")
        } else {
          // Data saved successfully!
        }
      });
  };

  @action getMeeting = async (sharecode: string, medium: string) => {
    // let ref = "/sharecodes/" + sharecode;
    // let dateObj = new Date().getTime();
    // if (medium == null || medium == undefined) {
    //   this.publicMeetingService.updateSharecodeAttribute(ref, "lastActivity", dateObj)
    // }
    // else {
    //   ref = ref + "/activityChannel/"
    //   this.publicMeetingService.updateSharecodeAttribute(ref, medium, dateObj)
    // }

    try {
      let meeting = await this.publicMeetingService.getMeetingId(sharecode);
      this.meetingId = meeting.meetingId;
      this.userId = meeting.userId;
      this.loadMeeting();
    } catch (error) {
      toast.error("Meeting not found");
    }
  } 
}
export default PublicMeetingStore;
